/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Loading from '../common/Loading';
import * as artistAdminActions from '../../actions/artistAdminActions';
import * as accountActions from '../../actions/accountActions';
import ToastrService from '../../services/toastrService';
import Compose from './Compose';
import Advert from '../common/Advert.js';
import * as imageUtils from '../../utils/imageUtils';

class MessagesPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.loadMessages = this.loadMessages.bind(this);
        this.closeConversation = this.closeConversation.bind(this);
        this.deleteConversation = this.deleteConversation.bind(this);
        this.showReply = this.showReply.bind(this);
        this.getReplyTo = this.getReplyTo.bind(this);
        this.reportSpam = this.reportSpam.bind(this);
        this.sendComplete = this.sendComplete.bind(this);
        this.replyComplete = this.replyComplete.bind(this);
        this.state = {
            messages: [],
            conversation: [],
            loading: false,
            showReply: false
        };
    }

    componentWillMount() {
        this.loadMessages();
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        const activeProfileSet = this.props.activeProfile && !prevProps.activeProfile;
        const activeProfileUpdated = this.props.activeProfile && prevProps.activeProfile && this.props.activeProfile.ID !== prevProps.activeProfile.ID;
        if(activeProfileSet || activeProfileUpdated || this.props.match.params.tabName !== prevProps.match.params.tabName) {
            this.loadMessages();
        }
    }

    loadMessages() {
        if(this.props.activeProfile && this.props.activeProfile.ID) {
            this.setState({ loading: true, messages: [], conversation: [] });
            const tabName = this.props.match.params.tabName? this.props.match.params.tabName.toLowerCase() : '';
            if(tabName !== 'compose') {
                const sentReceived = !tabName || tabName === 'inbox' ? 'Received' : 'Sent';
                this.props.actions.getMessages(this.props.activeProfile.ID, sentReceived)
                    .then(messages => {                    
                        this.setState({
                            messages, 
                            loading: false
                        });
                    })
                    .catch(error => {
                        this.setState({ loading: false });
                    });
            }
            else {
                this.setState({ loading: false });
            }
        }
    }    

    getThumbnail(imageUrl, roleType) {
        const params = '?width=90&aspectw=1&quality=80&mode=crop&format=jpg';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    }

    getTabClass(tabName) {
        let pageTabName = this.props.match.params.tabName || 'Inbox';
        return tabName.toLowerCase() == pageTabName.toLowerCase() ? 'active':'';
    }

    getTabUrl(tabName) {
        if(tabName === 'Inbox') {
            return '/Messages';
        }
        else {
            return `/Messages/${tabName}`;
        }
    }

    getConversation(event, conversationID) {
        if(event) {
            event.preventDefault();
        }
        const conversationRead = this.state.messages.find(m => m.ConversationID === conversationID).Read;
        this.props.actions.getConversation(this.props.activeProfile.ID, conversationID)
            .then(conversation => {            
                //mark the conversation as read, this is done in the back end too but we don't want to reload the message list just for the flag
                const messages = this.state.messages.map(message =>
                    message.ConversationID === conversationID ? { ...message, Read: true } : message
                );        
                this.setState({
                    conversation, 
                    messages,
                    loading: false
                }, () => {
                    if(!conversationRead) {
                        //now we've read it, reload the notifications
                        this.props.actions.refreshNotificationCount(this.props.activeProfile.ID);
                    }
                });                
            })
            .catch(error => {
                this.setState({ loading: false });
            });
    }    

    closeConversation(event) {
        event.preventDefault();
        this.setState({ conversation: [], showReply: false });
    }

    deleteConversation(event, conversationID) {
        event.preventDefault();
        if(confirm('Delete this conversation? This action cannot be undone!')) {
            this.props.actions.deleteConversation(this.props.activeProfile.ID, conversationID)
                .then(_ => {            
                    const toastrService = new ToastrService();
                    toastrService.showSuccess('', 'Conversation has been deleted successfully');
                    this.loadMessages();     
                })
                .catch(error => {
                    this.setState({ loading: false });

                });
        }
    }

    sendMessage(event) {
        event.preventDefault();
        const toastrService = new ToastrService();
        toastrService.showSuccess('', 'Message has been sent successfully');
    }

    showReply(event) {
        event.preventDefault();
        this.setState({ showReply: true });
    }

    getReplyTo() {
        const to = [];
        const message = this.state.conversation[0];
        const messageToIDs = Object.keys(message.To); 

        messageToIDs.forEach((id, i) => {
            const toItem = message.To[id];
            to.push({ 
                ID: toItem.ID, 
                Username: toItem.Username, 
                DisplayName: toItem.DisplayName,
                RoleType: toItem.RoleType
            });
        });

        to.push({
            ID: message.FromRoleID, 
            Username: message.FromUsername, 
            DisplayName: message.FromDisplayName,
            RoleType: message.FromRoleType
        });
        return to.filter(t => t.ID !== this.props.activeProfile.ID);
    }

    replyComplete(conversationID) {
        this.setState({ showReply: false });
        this.getConversation(null, conversationID);
    }

    sendComplete() {
        //redirect to sent messages, that should load the messages again
        this.props.history.push(`/Messages/Sent`);
    }

    reportSpam(event, messageID) {
        event.preventDefault();
        if (confirm('Report this message as spam?')) { 
            this.props.history.push(`/ReportSpam?roleID=${this.props.activeProfile.ID}&spamType=Message&id=${messageID}&returnUrl=${window.location.pathname}`);
        } 
    }

    render() {
        const tabName = this.props.match.params.tabName? this.props.match.params.tabName.toLowerCase() : '';
        const sentReceived = !tabName || tabName === 'inbox' ? 'Received' : 'Sent';            
        return (            
            <div className="main">
                <MetaTags>       
                    <title>Messages - LoudUp</title>     
                    <meta id="description" name="description" content="" />   
                </MetaTags>
                <div className="container">
                    <div className="block-inner minimal-height">
                        {
                            this.props.activeProfile ? 
                                <div className="row">
                                    <div className="col-md-12">
                                        <h1 className="section-alt">Messages</h1>
                                        <div className="tabbed-content tabs-stacked tabbed-content-profile">
                                            <ul id="profileTabs" className="nav nav-tabs" role="tablist">
                                                <li className={this.getTabClass('Compose')}>
                                                    <Link id="lnkCompose" className="transition" to={this.getTabUrl('Compose')}>
                                                        <svg className="icon icon-tab transition">
                                                            <use xlinkHref="#icn-compose" />
                                                        </svg>
                                                        <span className="title">Compose</span>
                                                    </Link>
                                                </li>
                                                <li className={this.getTabClass('Inbox')}>
                                                    <Link id="lnkInbox" className="transition" to={this.getTabUrl('Inbox')}>
                                                        <svg className="icon icon-tab transition">
                                                            <use xlinkHref="#icn-inbox" />
                                                        </svg>
                                                        <span className="title">Inbox</span>
                                                    </Link>
                                                </li>
                                                <li className={this.getTabClass('Sent')}>
                                                    <Link id="lnkSent" className="transition" to={this.getTabUrl('Sent')}>
                                                        <svg className="icon icon-tab transition">
                                                            <use xlinkHref="#icn-outbox" />
                                                        </svg>
                                                        <span className="title">Sent</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                            <div id="profilecontent" className="tabcontent tab-pane fade in active">
                                                {
                                                    !this.props.match.params.tabName || this.props.match.params.tabName !== 'Compose' ?
                                                        this.state.conversation.length ?
                                                            <div>
                                                                <a href="#" style={{ float:'right', fontSize: '1.2em' }} onClick={this.closeConversation}>&times;</a>
                                                                <p>
                                                                    <span style={{ fontWeight:'bold' }}>Subject: {this.state.conversation[0].Subject}</span>
                                                                </p>
                                                                <p className="messagebtns" style={{paddingTop: '10px'}}>
                                                                    <a className="btn-small" href="#" onClick={(e) => this.showReply(e)} style={{ fontWeight: 'bold'}}>Reply</a>
                                                                    <a className="btn-small" href="#" onClick={(e) => this.deleteConversation(e, this.state.conversation[0].ConversationID)} style={{ fontWeight: 'bold', float: 'right' }}>Delete conversation</a>
                                                                </p> 
                                                                <div id="replyContainer">
                                                                    {
                                                                        this.state.showReply ? 
                                                                            <Compose activeProfile={this.props.activeProfile} isReply subject={this.state.conversation[0].Subject} sendCallback={() => this.replyComplete(this.state.conversation[0].ConversationID)} to={this.getReplyTo()} conversationID={this.state.conversation[0].ConversationID} />
                                                                            : null
                                                                    }
                                                                </div>
                                                                <ul className="list-unstyled itemlist commentlist" style={{ marginTop: 0 }}>
                                                                    {
                                                                        this.state.conversation.map(message => {
                                                                            const messageToIDs = Object.keys(message.To); 
                                                                            return <li key={message.ID}>
                                                                                <Link to={`/${message.FromUsername}`} className="thumbnail">
                                                                                    <div className="userthumb">
                                                                                        <img src={this.getThumbnail(message.Thumbnail, message.FromRoleType)} alt="profile picture" />
                                                                                    </div>
                                                                                </Link>
                                                                                <p className="length">{new Date(message.Date).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                                                                                <h2>
                                                                                    <Link to={`/${message.FromUsername}`} className="transition link" title={message.FromUsername} style={{fontWeight: message.Read ? 'normal' : 'bold'}}>{message.FromDisplayName}</Link>
                                                                                    {
                                                                                        !message.Read ?
                                                                                            <span style={{color: '#E55D1E', fontWeight: 'bold', paddingLeft: '20px'}}>NEW!</span>
                                                                                        : null
                                                                                    }
                                                                                </h2>
                                                                                <p>
                                                                                    <span>To: </span>
                                                                                    {
                                                                                        messageToIDs.map((id, i) =>
                                                                                            <React.Fragment key={id}>
                                                                                                <Link to={`/${message.To[id].Username}`} className="transition link">{`${message.To[id].DisplayName}${i < messageToIDs.length - 1 ? ', ' : ''}`}</Link>
                                                                                                {
                                                                                                    i === 2 && i < messageToIDs.length > 2 ?
                                                                                                        <span style={{fontWeight: 'normal', color: 'aaa'}}>+ {messageToIDs.length - i} more </span>
                                                                                                        : null
                                                                                                }
                                                                                            </React.Fragment>
                                                                                        )    

                                                                                    }
                                                                                </p>
                                                                                <div className="message">
                                                                                    <p>{message.Body}</p>
                                                                                </div>
                                                                                {
                                                                                    message.FromRoleID !== this.props.activeProfile.ID ?
                                                                                        <a href="#" onClick={(e) => this.reportSpam(e, message.ID)} style={{float: 'right', color: 'navy', fontSize: '0.8em'}}>Report spam</a>
                                                                                    : null
                                                                                }
                                                                            </li>;
                                                                        })
                                                                    }
                                                                </ul>
                                                            </div>
                                                            :
                                                            this.state.messages.length ?
                                                                <ul className="list-unstyled itemlist commentlist inboxlist" style={{marginTop: 0}}>
                                                                {
                                                                    this.state.messages.map(message => {
                                                                        const messageToIDs = Object.keys(message.To); 
                                                                        return <li key={message.ID} className="transition" onClick={(e) => this.getConversation(e, message.ConversationID)}>
                                                                            <a href="#" onClick={(e) => this.getConversation(e, message.ConversationID)} className="thumbnail">
                                                                                <div className="userthumb">
                                                                                    <img src={this.getThumbnail(message.Thumbnail, message.FromRoleType)} alt="profile picture" />
                                                                                </div>
                                                                            </a>
                                                                            <p className="length">{new Date(message.Date).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                                                                            <h2>
                                                                                {
                                                                                    sentReceived === 'Received' ?
                                                                                        <Link to={`/${message.FromUsername}`} className="transition link" style={{fontWeight: message.Read ? 'normal' : 'bold'}}>{message.FromDisplayName}</Link>
                                                                                        :
                                                                                            messageToIDs.slice(0, 3).map((id, i) =>
                                                                                                <React.Fragment key={id}>
                                                                                                    <Link to={`/${message.To[id].Username}`} className="transition link">{`${message.To[id].DisplayName}${i < 2 && i < messageToIDs.length - 1 ? ', ' : ''}`}</Link>
                                                                                                    {
                                                                                                        i === 2 && i < messageToIDs.length > 2 ?
                                                                                                            <span style={{fontWeight: 'normal', color: 'aaa'}}>+ {messageToIDs.length - i} more </span>
                                                                                                            : null
                                                                                                    }
                                                                                                </React.Fragment>
                                                                                            )                                                                             
                                                                                }
                                                                                {
                                                                                    sentReceived === 'Received' && !message.Read ?
                                                                                        <span style={{color: '#E55D1E', fontWeight: 'bold', paddingLeft: '20px'}}>NEW!</span>
                                                                                        : null
                                                                                }
                                                                            </h2>
                                                                            <p className="subject">
                                                                                <a style={{fontWeight: message.Read ? 'normal' : 'bold'}} href="#" onClick={(e) => this.getConversation(e, message.ConversationID)}>Subject: {message.Subject}</a>
                                                                            </p>
                                                                            <div className="message">
                                                                                <p>{message.Body.substring(0, 100)}</p>
                                                                            </div>
                                                                        </li>;
                                                                    })
                                                                }
                                                                </ul>
                                                            :
                                                                this.state.loading ?
                                                                    <Loading />
                                                                :   <p>Sorry, nothing to see here! :)</p>
                                                    :
                                                    <Compose activeProfile={this.props.activeProfile} sendCallback={this.sendComplete} />
                                                }
                                            </div>
                                        </div>
                                        <aside className="artist-sidebar">
                                            <div className="content-side">
                                                <Advert adType="Side" />
                                            </div>
                                        </aside>
                                    </div>
                                </div>
                            : <div />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

MessagesPage.propTypes = {
    activeProfile: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return { activeProfile: state.account.user.activeProfile };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, artistAdminActions, accountActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessagesPage);